import {
  bandInvitationMetaSelector,
  bandInvitationSelectorCreator,
  dispatchGetBandInvitationAction,
} from "Bands/state";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useQueryParams, StringParam } from "use-query-params";

export const useGetBandInvitation = (overrideInvitationId?: string | null) => {
  const dispatch = useDispatch();

  const [{ bandInvite }] = useQueryParams({
    bandInvite: StringParam,
  });

  const bandInvitationId = useMemo(
    () => overrideInvitationId || bandInvite,
    [bandInvite, overrideInvitationId]
  );

  const { api: bandInvitationMeta } = useSelector(
    bandInvitationMetaSelector(bandInvitationId as string)
  );

  useEffect(() => {
    if (bandInvitationId) {
      dispatchGetBandInvitationAction(dispatch, bandInvitationId);
    }
  }, [bandInvitationId, dispatch]);

  const bandInvitationSelector = useMemo(
    () => bandInvitationSelectorCreator(bandInvitationId || ""),
    [bandInvitationId]
  );
  const bandInvitation = useSelector(bandInvitationSelector);

  return {
    bandInvitationId,
    bandInvitation,
    bandInvitationMeta,
  };
};
